import { Component } from '@angular/core';
import { NavController, ModalController, ToastController, LoadingController,NavParams } from 'ionic-angular';
import { Camera, CameraOptions } from '@ionic-native/camera';

import { Master, Item  } from '@providers/asset/index';
declare var cordova:any;

@Component({
  selector: 'page-form_location',
  templateUrl: 'page.html'
})
export class FormLocationPage {

  item = {
    id: '',
    location_name: '',
    location_code: '',
    parent_id: '',
    description: '',
    level_id: '',
    location_path_id: '',
    dokument_id:'',
    generated_name:''
  };
  list_path:any=[];
  url_img='';

  constructor(
    public MasterApi: Master,
    public itemApi: Item,
    public camera: Camera,
    public navCtrl: NavController,
    public modalCtrl: ModalController,
    public toastCtrl: ToastController,
    public loadingCtrl: LoadingController, 
    navParams: NavParams
  ) {
    if(navParams.get('parent')!=undefined){
      let p = navParams.get('parent');
      this.item.parent_id = p.parent_id;
      this.getPath(p.location_path_id);
    }

    if(navParams.get('item')!=undefined){
      this.item = navParams.get('item');
      this.getPath(this.item.location_path_id);

    }
    this.url_img = itemApi.base_url+"/client/uploads/";
  }
  
  simpan(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    let params = this.item;
    this.MasterApi.saveLocation(params).subscribe((resp:any) => {
      this.item.id = resp.data.id;
      loading.dismiss();
    }, (err) => {
      loading.dismiss();
    });
  }

  getPath(location_path){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    let params = { location_path: location_path };
    
    this.MasterApi.getLocation(params).subscribe((resp:any) => {
      if(resp.data.length>0){
        this.list_path = resp.data;
      }else{
        
      }
      loading.dismiss();
    }, (err) => {
      loading.dismiss();
    });
  }

  takePicture(){
    const options: CameraOptions = {
      quality: 50,
      destinationType: this.camera.DestinationType.DATA_URL
    }
    
    this.camera.getPicture(options).then((imageData) => {
     // imageData is either a base64 encoded string or a file URI
     // If it's base64 (DATA_URL):
     let base64Image = 'data:image/jpeg;base64,' + imageData;
     this.save_image(base64Image);
    }, (err) => {
     // Handle error
    });
  }

  save_image(img){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    let params = {img: img};
    this.itemApi.save_image(params).subscribe((resp:any) => {
      this.item.dokument_id=resp.data.id;
      this.item.generated_name=resp.data.generated_name;
      loading.dismiss();
    }, (err) => {
      loading.dismiss();
    });
  }



  sendtoPrinter(){
    let codeCanvas = document.querySelectorAll('canvas');
    console.log(codeCanvas[0]);
    let code = codeCanvas[0];
    let img = code.toDataURL("image/jpeg");
    img = img.substr(23);
    let me = this;
    cordova.plugins.brotherPrinter.findBluetoothPrinters(function(printers){
        cordova.plugins.brotherPrinter.setPrinter(printers[0], function(){
          cordova.plugins.brotherPrinter.printViaSDK(img,function(statusCode){
          },function(err){
          });
        },function(err) {
          console.log(err);
        });
    },function(err){
        console.log(err)
    });
  }

  print(){
    let codeCanvas = document.querySelectorAll('canvas');
    console.log(codeCanvas[0]);
    let code = codeCanvas[0];
    let img = code.toDataURL("image/jpeg");
    console.log(img);
    img = img.substr(23);
    console.log(img);
    let me = this;
    cordova.plugins.brotherPrinter.findBluetoothPrinters(function(printers){
        console.log("Success");
        console.log(printers);

        cordova.plugins.brotherPrinter.setPrinter(printers[0], function(){
          console.log('set');
          cordova.plugins.brotherPrinter.printViaSDK(img,function(statusCode){
            console.log(statusCode);
            console.log('printed');
          },function(err){
            console.log(err);
            console.log('errrore');
          });
          
        },function(err) {
          console.log(err);
        });

        

    },function(err){
        console.log("Error");
        console.log(err)
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/asset/form_location/page.ts